<template>
	<vs-list v-if="list.length > 0">
		<vs-list-item
			v-for="(listItem, index) in list"
			:title="resolveListItemTitle(listItem) | capitalize"
			class="list-item"
			:key="index"
		>
			<template slot="avatar">
				<vs-avatar
					:class="resolveStatusColor(listItem.event_status_id)"
					icon-pack="feather"
					icon="icon-calendar"
					class="mr-2"
					:title="eventStatusTranslate(listItem.event_status_id)"
				/>
			</template>

			<template slot="subtitle">
				<span class="text-sm"> {{ listItem.date_prog }}, </span>

				<span class="text-sm"> {{ listItem.init_hour }} - {{ listItem.end_hour }} </span>
			</template>

			<div class="flex flex-row flex-wrap items-center gap-1">
				<vs-button
					color="primary"
					icon-pack="feather"
					icon="icon-settings"
					@click.stop="action('edit', index)"
					:title="
						$t('View') +
						', ' +
						$t('Schedule.UpdateVisitInformation') +
						', ' +
						$t('Schedule.RescheduleVisit')
					"
				></vs-button>

				<vs-button
					color="danger"
					icon-pack="feather"
					icon="icon-minus-circle"
					@click.stop="action('cancel', index)"
					:title="$t('Schedule.CancelVisit')"
				></vs-button>

				<vs-button
					color="success"
					icon-pack="feather"
					icon="icon-check-square"
					@click.stop="action('finalize', index)"
					:title="$t('Schedule.Finalize')"
					v-show="listItem.event_status_id === 6"
				></vs-button>
			</div>
		</vs-list-item>
	</vs-list>
</template>
<script>
export default {
	props: {
		events: {
			type: Array,
			required: true,
		},
		action: {
			type: Function,
			required: false,
		},
	},
	data() {
		return {
			list: this.events,
			listSize: this.events.length,
		};
	},
	computed: {
		eventStatusTranslate() {
			return (label) => {
				let text = "";
				switch (label) {
					case 1:
						text = this.$t("Schedule.NotAssigned");
						break;
					case 2:
						text = this.$t("Schedule.Scheduled");
						break;
					case 3:
						text = this.$t("Schedule.ReProgramming");
						break;
					case 4:
						text = this.$t("Schedule.Delayed");
						break;
					case 5:
						text = this.$t("Schedule.OnTheWay");
						break;
					case 6:
						text = this.$t("Schedule.InProgress");
						break;
					case 7:
						text = this.$t("Schedule.Finished");
						break;
					case 8:
						text = this.$t("Schedule.Canceled");
						break;
					default:
						break;
				}
				return text;
			};
		},

		resolveStatusColor() {
			return (status) => {
				if (status === 1) return "bg-ondemand";
				else if (status === 2) return "bg-agendado";
				else if (status === 3) return "bg-reprogramado";
				else if (status === 4) return "bg-delayed";
				else if (status === 5) return "bg-on-the-way";
				else if (status === 6) return "bg-en_proceso";
				else if (status === 7) return "bg-finalizado";
				else if (status === 8) return "bg-cancelado";
				else return "bg-selected";
			};
		},

		resolveListItemTitle() {
			return (listItem) => {
				return listItem.activity_name + " - " + listItem.visit_point_name;
			};
		},
	},
};
</script>
<style>
.list-item {
	transition: all 1s;
}

.bg-agendado {
	background-color: #28c76f !important;
}
.bg-reprogramado {
	background-color: #006eff !important;
}
.bg-cancelado {
	background-color: #ff0000 !important;
}
.bg-finalizado {
	background-color: #19663b !important;
}
.bg-en_proceso {
	background-color: #ff9f43 !important;
}
.bg-delayed {
	background-color: #ff7070 !important;
}
.bg-on-the-way {
	background-color: #ffbe81 !important;
}
.bg-selected {
	background-color: #a0a0a0 !important;
}
.bg-ondemand {
	background-color: #886ce4 !important;
}
</style>
